
import { createAction, handleActions } from 'redux-actions';

const setShowValuationCompletionModal = createAction("SCREENS/VALUATION_VIEW/SET_SHOW_VALUATION_COMPLETION_MODAL");

const defaultState = false;

const reducer = handleActions(
  {
    [setShowValuationCompletionModal]: (state, action) => action.payload
  },
  defaultState
);

export { setShowValuationCompletionModal, reducer };